import { useCallback, useMemo, useState, useEffect } from 'react';

export function useOnChildrenRendered({
	componentList = [],
	onAllChildrenRendered = undefined,
}: {
	componentList: any[];
	onAllChildrenRendered?: () => void;
}) {
	const [areAllChildrenRendered, setAreAllChildrenRendered] = useState(false);
	const renderedItems = new Set<number>();

	if (onAllChildrenRendered === undefined) {
		return { onItemRendered: () => () => {} };
	}

	const onItemRendered = useCallback(
		(index: number) =>
			useMemo(
				() => () => {
					if (!renderedItems.has(index)) {
						renderedItems.add(index);
					}
					if (renderedItems.size === componentList.length) {
						setAreAllChildrenRendered(true);
					}
				},
				[index]
			),
		[]
	);

	useEffect(() => {
		if (componentList.length === 0) {
			setAreAllChildrenRendered(true);
		}
	}, [componentList.length]);

	useEffect(() => {
		if (!areAllChildrenRendered) return;

		onAllChildrenRendered();
	}, [areAllChildrenRendered]);

	return { onItemRendered, areAllChildrenRendered };
}
